import api from 'config/Api/Api';

const baseEndpoint = 'v1/direct-area';

export default {
  getCountries() {
    return api.get( `${baseEndpoint}/direct-dial` );
  },
};
